// LEGACY UI: replace with Skeleton from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import RowPlaceholder from "./RowPlaceholder";

const SelectPlaceholder = () => (
  <div className="p-2">
    {Array.from({ length: 9 }, (index: number) => (
      <RowPlaceholder key={index} />
    ))}
  </div>
);

export default SelectPlaceholder;
